export const PLATFORMS = ["API", "APP", "WP", "FE","SSO","NG_MIGRATION","ALL"];
